import icon from 'vue-svgicon';

icon.register({
  wheel: {
    width: 40,
    height: 40,
    viewBox: '0 0 40 40',
    // eslint-disable-next-line max-len
    data: '<path class="zu-wheel" d="m38 20c0-9.94-8.06-18-18-18s-18 8.06-18 18 8.06 18 18 18 18-8.06 18-18zm-4.5 0c0 5.86-3.77 10.81-9 12.67v-25.34c5.23 1.86 9 6.81 9 12.67zm-15.75 0c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25-1.01 2.25-2.25 2.25-2.25-1.01-2.25-2.25zm2.25-13.5c0 6.15-5.92 11.13-13.27 11.23 1.09-6.36 6.6-11.23 13.27-11.23zm-13.27 15.77c7.35 0.1 13.27 5.08 13.27 11.23-6.67 0-12.18-4.87-13.27-11.23z"></path>',
  },
});



// WEBPACK FOOTER //
// ./src/components/svg/_components/wheel.js